import { gitColumnFilter, gitColumnMapping, gitTabGroups } from './CatalogTypes/2gitTypes'
import { gsaColumnFilter, gsaColumnMapping, gsaTabGroups } from './CatalogTypes/gsaTypes'
import { sewpColumnFilter, sewpColumnMapping, sewpTabGroups } from './CatalogTypes/sewpTypes'
import { itesColumnFilter, itesColumnMapping, itesTabGroups } from './CatalogTypes/itesTypes'
import { ReactElement } from 'react'
import { naspoColumnFilters, naspoColumnMapping, naspoTabGroups } from './CatalogTypes/naspoTypes'

export interface catalogItemType {
  id: string
  oemCode: string
  mfrPartNumber: string
  manufacturer: string
  previouslyApprovedClin: string | undefined
}

export interface catalogModType {
  id: string
  modType?: string
  prodType?: string
  modDate?: Date
  status: 'inProgress' | 'processing' | 'completed' | 'failed'
  errorMessage?: string
  uploadedFile: string
  uploadedDate: Date
  oldPrice?: number
  updatedPrice?: number
}

export type catalogColumnType = {
  key: string
  value?: React.ReactNode
  label: string
  width?: string | undefined
  align?: 'left' | 'center' | 'right'
  defaultHidden?: boolean
  editable?: boolean
  options?: { label: string; value: string | number | boolean | null }[]
  inputType?: 'boolean' | 'currency' | 'date' | 'number' | 'percentage' | 'string' | 'autocomplete'
  limit?: number
  sticky?: { left: string }
  source?: 'manufacturer'
}

export type catalogFilterColumnType = { key: string; label: string; type?: 'date' }

export type catalogTabType = {
  label: string
  icon?: ReactElement
  source: string
  modType?: string
  isModification?: boolean
  isTrHeader?: boolean
  isArHeader?: boolean
  filters?: { [k: string]: string }
}

export const catalogModTypeList = ['Price Increase', 'Price Decrease', 'Additions', 'Deletions']

export const catalogColumns = new Map<string, Map<string, catalogColumnType[]>>([
  ['gsa', gsaColumnMapping],
  ['gsabpa', gsaColumnMapping],
  ['sewp', sewpColumnMapping],
  ['2git', gitColumnMapping],
  ['ites', itesColumnMapping],
  ['naspo', naspoColumnMapping],
])

export const catalogTabGroups = new Map<string, Map<string, catalogTabType[]>>([
  ['gsa', gsaTabGroups],
  ['gsabpa', gsaTabGroups],
  ['sewp', sewpTabGroups],
  ['2git', gitTabGroups],
  ['ites', itesTabGroups],
  ['naspo', naspoTabGroups],
])

export const catalogColumnFilters = new Map<string, Map<string, catalogFilterColumnType[]>>([
  ['gsa', gsaColumnFilter],
  ['sewp', sewpColumnFilter],
  ['2git', gitColumnFilter],
  ['ites', itesColumnFilter],
  ['naspo', naspoColumnFilters],
])
